<template>
	<div style="padding-bottom: 20px;">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>
		<van-form @submit="onSubmit">
			<div
				class="form-item"
				v-for="(item, index) in assign_list"
				:key="index"
			>
				<van-field
					v-model="assign_list[index].names"
					:label="item.node_name"
					placeholder="请选择分配用户"
					readonly
					@click="selectPopup(index)"
					:rules="[
						{
							required: true,
							trigger: 'onBlur',
							message: '请选择分配用户',
						},
					]"
				/>
				<van-field
					v-model="assign_list[index].predict_date"
					label="预计完成日期"
					placeholder="选择预计完成日期"
					readonly
					@click="calendarPopup(index)"
					:rules="[
						{
							required: true,
							trigger: 'onBlur',
							message: '请选择预计完成日期',
						},
					]"
				/>
				<van-field
					v-model="assign_list[index].assign_remark"
					rows="3"
					autosize
					label="指派说明"
					type="textarea"
					placeholder="请输入指派说明"
					:rules="[
						{
							required: false,   //false可选，true必须
							trigger: 'onBlur',
							message: '请输入指派说明',
						},
					]"
				/>
			</div>

			<van-panel class="schedule" title="附件">
				<div class="schedule-body">
					<div
						class="file-body"
						v-for="(item, index) in file_list"
						:key="index"
					>
						<div class="file-body-item">
							<div
								class="img-body"
								v-if="isTypeImage(item.file_type)"
							>
								<van-image
									width="100"
									height="100"
									:src="fileUrl + item.file_id"
									@click="imgLook(fileUrl + item.file_id)"
								/>
							</div>
							<div class="img-body" v-else @click="clickFile">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">
									{{ item.file_name }}.{{ item.file_type }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-panel>

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit"
					>提交</van-button
				>
			</div>
		</van-form>

		<van-popup
			v-model="popup.user"
			position="right"
			:style="{ width: '60%', height: '100%' }"
		>
			<popup-select
				v-model="userList.list"
				@onload="onload"
				@check="check"
				:loading="userList.loading"
				:finished="userList.finished"
				value-key="user_name"
				id-key="user_id"
				type="select"
				:value="select_value"
			></popup-select>
		</van-popup>
		<van-calendar v-model="popup.calendar" @confirm="confirmCalendar" />
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import popupselect from "@/components/select/index";
import { Toast } from "vant";
import { post } from "@/api/dispatch";
import { getNowFormatDate, isImage } from "@/utils/tool";
import { ImagePreview } from "vant";

export default {
	name: "customer",
	components: {
		navbar,
		"popup-select": popupselect,
	},
	data() {
		return {
			title: "派单分配",
			assign_list: [],
			file_list: [],
			popup_index: {
				select: 0,
				calendar: 0,
			},
			form: [],
			select_value: [],
			popup: {
				user: false,
				calendar: false,
			},
			userList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20,
			},
		};
	},
	mounted() {
		this.getDetails();
	},
	methods: {
		getDetails() {
			post({
				requestType: "event_list_data_echo",
				dispatch_id: this.$route.query.id,
			})
				.then((res) => {
					this.assign_list = JSON.parse(res.obj.assign_list);
					if (!this.file_list) {
						this.file_list = JSON.parse(res.obj.file_list);
					}
					this.assign_list.forEach((item, index) => {
						if (!item.user_list) {
							this.assign_list[index].user_list = [];
						} else if (item.user_list.indexOf(",") === -1) {
							this.assign_list[index].user_list = [
								Number(item.user_list),
							];
						} else {
							let list = item.user_list.split(",");
							list.forEach((item, index) => {
								list[index] = Number(item);
							});
							this.assign_list[index].user_list = list;
						}
					});
				})
				.catch((err) => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		onSubmit() {
			this.assign_list.forEach((item, index) => {
				if (Array.isArray(item.user_list)) {
					this.assign_list[index].user_id = item.user_list;
				}
			});

			post({
				requestType: "event_assign_people",
				dispatch_id: this.$route.query.id,
				node_list: JSON.stringify(this.assign_list),
			})
				.then(() => {
					Toast.success("提交成功");
					this.$router.go(-1);
				})
				.catch((err) => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		calendarPopup(index) {
			this.popup.calendar = true;
			this.popup_index.calendar = index;
		},
		confirmCalendar(value) {
			this.assign_list[
				this.popup_index.calendar
			].predict_date = getNowFormatDate(value);
			this.popup.calendar = false;
		},
		onload(search) {
			// 防止重复请求
			if (this.userList.loading) {
				return;
			}
			// 设置加载状态
			this.userList.loading = true;
			if (search != undefined) {
				this.userList.page = 1;
			}
			post({
				requestType: "assign_people",
				page: this.userList.page,
				limit: this.userList.limit,
				user_name: search,
			})
				.then((res) => {
					if (res.obj.rows.length === 0) {
						this.userList.finished = true;
					}
					if (this.userList.page != 1) {
						this.userList.list = this.userList.list.concat(
							res.obj.rows
						);
					} else {
						this.userList.list = res.obj.rows;
					}

					this.userList.page += 1;
					this.userList.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.userList.loading = false;
					this.userList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		check(value, type, index) {
			console.log(type);
			let select = this.popup_index.select;
			if (type == "add") {
				if (!this.assign_list[select].names) {
					this.assign_list[select].names = value.user_name;
				} else {
					this.assign_list[select].names += "," + value.user_name;
				}
				if (!this.assign_list[select].user_list) {
					this.assign_list[select].user_list = [
						Number(value.user_list),
					];
				} else {
					this.assign_list[select].user_list.push(
						Number(value.user_id)
					);
				}
			} else {
				let names = this.assign_list[select].names.split(",");
				names.splice(index, 1);
				names = names.join(",");
				this.assign_list[select].names = names;
				this.assign_list[select].user_list.splice(index, 1);
			}
		},
		isTypeImage(name) {
			return isImage(name);
		},
		imgLook(url) {
			ImagePreview({
				images: [url],
			});
		},
		clickFile() {
			return Toast.fail("暂不支持该文件查看");
		},
		selectPopup(index) {
			this.popup.user = true;
			this.popup_index.select = index;
			if (!this.assign_list[index].user_list) {
				this.select_value = [];
			} else {
				this.select_value = this.assign_list[index].user_list;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.form-item {
	margin-top: 10px;
}
.schedule {
	margin-top: 30px;
	overflow: hidden;
	.van-panel__content {
		padding: 10px 20px;
	}
	&-body {
		font-size: 0.8em;
		p {
			margin: 0.5em 0;
		}
	}
	.file-body {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-top: 15px;

		float: left;
		margin-left: 15px;
		&:nth-child(3n-2) {
			margin-left: 0;
		}
		&-item {
			position: relative;
			margin: 0 8px 8px 0;
			cursor: pointer;
			.img-body {
				display: block;
				width: 80px;
				height: 80px;
				overflow: hidden;
				border-radius: 8px;
				box-shadow: #ebedf0 0 4px 12px;
				text-align: center;
				img {
					object-fit: cover;
					display: block;
					width: 100%;
					height: 100%;
				}
				.file-icon {
					position: relative;
					display: inline-block;
					font: normal normal normal 14px/1 "vant-icon";
					font-size: inherit;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					color: #646566;
					font-size: 20px;
					margin-top: 15px;
				}
				.file-name {
					box-sizing: border-box;
					width: 100%;
					margin-top: 4px;
					padding: 0 4px;
					color: #646566;
					font-size: 12px;
					text-align: center;
				}
			}
		}
	}
}
</style>
